<template>
	<router-link
		:aria-label="caption"
		:to="link"
	><b-icon :icon="icon"></b-icon><span class="sidebar-hidden-closed">{{caption}}</span></router-link>
</template>

<script>
export default {
	props: {
		caption: String,
		link: String,
		icon: String
	}
};
</script>
